export enum DeleteType {
	dmriTestOnly = 0,
	dmriTestAndDeactivate = 1,
	dmriTestAndFullDeleteIfPossible = 2,
	dmriTestAndMakeComplete = 3,
}
